export enum ECurrencySymbolPosition {
	FRONT = 'front',
	BACK = 'back',
}

export enum ECurrency {
	PLN = 'PLN',
	EUR = 'EUR',
	GBP = 'GBP',
	USD = 'USD',
	CZK = 'CZK',
	HUF = 'HUF',
	RON = 'RON',
	SEK = 'SEK',
	DKK = 'DKK',
	NOK = 'NOK',
}
